import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environments';
import {HttpClient} from '@angular/common/http';
import {map, Observable, throwError} from 'rxjs';


export interface CheckoutOrder {
    userId: number;
    paymentMethod: 'Bank' | 'Paypal';
    customer: {
        companyName:string;
        firstname: string;
        lastname: string;
        email: string;
        address: string;
        town: string;
    };
    orderDetails: {
        table: string;
        states: string[];
        infos: string[];
        quantity: number;
        price: number;
    };
}

export interface CheckoutResponse {
    success: boolean;
    message: string;
    orderId: string;
}

@Injectable({
    providedIn: 'root'
})
export class CheckoutService {

    private readonly apiUrl = `${environment.apiUrl}/checkout`;

    constructor(private http: HttpClient) {}

    /** Send the complete order to the backend */
    placeOrder(order: CheckoutOrder): Observable<CheckoutResponse> {
        return this.http.post<CheckoutResponse>(this.apiUrl, order);
    }
}
